module.exports = __webpack_public_path__ + "static/media/left-arrow.83b316ba.svg";